var _path, _path2, _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomatedTrafficFineNotificationVehiclesNotify(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8009 2.26782C2.82587 2.26782 1.22079 3.8729 1.22079 5.84792V7.57234C1.22079 7.93632 1.06566 8.49123 0.880685 8.80151L0.194499 9.94117C-0.229146 10.6453 0.0632288 11.4269 0.838918 11.6895C3.41062 12.5487 6.1852 12.5487 8.75691 11.6895C9.4789 11.4508 9.79514 10.5975 9.40133 9.94117L8.71514 8.80151C8.53614 8.49123 8.381 7.93632 8.381 7.57234V5.84792C8.381 3.87887 6.76995 2.26782 4.8009 2.26782Z",
    fill: "#EE0033"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60946 13.0149C5.43152 13.2345 4.17403 13.2394 2.96143 13.0149C2.96143 13.9101 4.01307 14.4893 4.86668 14.5292C5.93272 14.5791 6.60946 13.8372 6.60946 13.0149Z",
    fill: "#EE0033"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4632_25745)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.98584,
    y: 0.531494,
    width: 8.63762,
    height: 8.63762,
    rx: 4.31881,
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.90633,
    cy: 4.4515,
    r: 3.65438,
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15241 4.08861C9.03591 4.08861 8.92945 4.17994 8.9346 4.29632C8.94012 4.42098 8.84069 4.52377 8.71725 4.52377H8.28208C8.16191 4.52377 8.0645 4.42636 8.0645 4.30619C8.0645 4.18602 7.96709 4.08861 7.84692 4.08861H7.41175C7.2395 4.08861 7.07394 4.1172 6.91953 4.1699C6.31991 4.37455 5.88867 4.94276 5.88867 5.61169C5.88867 6.45285 6.57059 7.13476 7.41175 7.13476C7.46288 7.13476 8.53192 7.14176 8.84772 6.0622C8.96076 5.67577 9.29094 5.3941 9.69356 5.3941H10.5885C10.8288 5.3941 11.0236 5.19926 11.0236 4.95894V4.52377C11.0236 4.28344 10.8288 4.08861 10.5885 4.08861H9.15241Z",
    stroke: "white",
    strokeWidth: 0.664432,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54297 6.25C7.83951 6.18921 8.0625 5.9257 8.0625 5.61133C8.06228 5.25234 7.77109 4.96115 7.41211 4.96094C7.09774 4.96094 6.83423 5.18393 6.77344 5.48047L6.76074 5.61133L6.77344 5.74316C6.8343 6.03962 7.0978 6.2627 7.41211 6.2627L7.54297 6.25Z",
    stroke: "white",
    strokeWidth: 0.664432,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45703 2.34706V2.78223",
    stroke: "white",
    strokeWidth: 0.664432,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53467 2.90958L7.84238 3.21729",
    stroke: "white",
    strokeWidth: 0.664432,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38046 2.90958L9.07275 3.21729",
    stroke: "white",
    strokeWidth: 0.664432,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.98584,
    y: 0.531494,
    width: 8.63762,
    height: 8.63762,
    rx: 4.31881,
    stroke: "white",
    strokeWidth: 1.06309
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4632_25745"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.98584,
    y: 0.531494,
    width: 8.63762,
    height: 8.63762,
    rx: 4.31881,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatedTrafficFineNotificationVehiclesNotify);
export default __webpack_public_path__ + "static/media/AutomatedTrafficFineNotificationVehiclesNotify.b13b8baecef636a1d4e60b205bff75c9.svg";
export { ForwardRef as ReactComponent };